/**
 * Build share URLs and copy helpers (client only for URLs).
 */

export function getPostShareUrl(postId) {
  if (typeof window === 'undefined') return '';
  const id = typeof postId === 'number' ? postId : parseInt(postId, 10);
  if (!id || Number.isNaN(id)) return '';
  return `${window.location.origin}/posts/${id}`;
}

export function getProfileShareUrl(username) {
  if (typeof window === 'undefined' || !username) return '';
  return `${window.location.origin}/profile/${encodeURIComponent(username)}`;
}

export async function copyTextToClipboard(text) {
  if (!text) return false;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* fall through */
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
